import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('jobrad_bidex_categories'),
];
